import React from 'react';

// BIGTIME brand — official assets provided by the client.
// DO NOT redraw or approximate these logos with inline SVG. Always use the
// PNG files in /public/brand/.
//
// Files:
//   *.png              — original (navy ink over yellow tile, for print/light bg)
//   *-yellow.png       — yellow ink on transparent bg (for dark navy backgrounds)
//
// Variants: 'horizontal' | 'stacked' | 'mono'
// Mode:
//   'on-dark'  → uses -yellow.png (transparent bg, yellow ink)     [default]
//   'on-light' → uses original.png (navy ink over yellow tile)
//   'ink'      → alias for on-dark (yellow ink transparent)

const FILES = {
  horizontal: { dark: '/brand/bigtime-horizontal-yellow.png', light: '/brand/bigtime-horizontal.png' },
  stacked:    { dark: '/brand/bigtime-stacked-yellow.png',    light: '/brand/bigtime-stacked.png' },
  mono:       { dark: '/brand/bigtime-mono-yellow.png',       light: '/brand/bigtime-mono.png' },
};

export default function Logo({
  className = 'h-10',
  variant = 'horizontal',
  mode = 'on-dark',
}) {
  const pair = FILES[variant] || FILES.horizontal;
  const src = mode === 'on-light' ? pair.light : pair.dark;
  return (
    <img
      src={src}
      alt="BIGTIME"
      className={`${className} block object-contain`}
      draggable={false}
    />
  );
}
